var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowWideWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.4,29.7L44.7,2.1L44.8,2l-0.3-0.3c-0.2-0.3-0.8-0.3-1.3,0L15.5,29.5c-0.3,0.3-0.3,0.8,0,1.3l27.8,27.5l0,0 c0.2,0.1,0.5,0.2,0.7,0.2c0.2,0,0.4-0.1,0.6-0.2l0.3-0.3L17.4,30.6c-0.2-0.2-0.3-0.4-0.3-0.6C17.1,29.8,17.2,29.7,17.4,29.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.8,28.6L101.7,1.7l0,0c-0.5-0.2-1-0.2-1.2,0L100.1,2l26.7,26.7c0.2,0.2,0.3,0.4,0.3,0.6 c0,0.1-0.1,0.2-0.2,0.3l-26.6,26.8l-0.1,0.1l0.3,0.3c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.7-0.2l27.1-27.1 C129,29.6,129,29.1,128.8,28.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWideWhite);
export default __webpack_public_path__ + "static/media/arrow_wide_white.cf61754d50b9ebc16f76f28ed3540008.svg";
export { ForwardRef as ReactComponent };